<template>
  <div class="scrollable-panel__wrapper" ref="scrollWrapper">
    <div class="scrollable-panel">
      <div class="scrollable-panel__left">
        <div class="scrollable-panel__col__header start">
          <slot name="left-panel-header"></slot>
        </div>
        <div class="scrollable-panel__col__body start">
          <slot name="left-panel-body"></slot>
        </div>
      </div>
  
      <div class="scrollable-panel__center">
        <div class="scrollable-panel__col__header center">
          <slot name="center-panel-header"></slot>
        </div>
        <div class="scrollable-panel__col__body center">
          <slot name="center-panel-body"></slot>
        </div>
      </div>
  
      <div class="scrollable-panel__right">
        <div class="scrollable-panel__col__header end">
          <slot name="right-panel-header"></slot>
        </div>
        <div class="scrollable-panel__col__body end">
          <slot name="right-panel-body"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script lang="ts">
import { defineComponent, nextTick } from 'vue';

export default defineComponent({
  props: {
    initialScrollX: {
      type: Number,
      default: 0
    },
  },
  mounted() {
    const applyScroll = () => {
      const wrapper = this.$refs.scrollWrapper as HTMLDivElement;
      if (wrapper) {
        wrapper.scrollLeft = this.initialScrollX;
      }
    };

    // 初回実行
    applyScroll();
    
    // レイアウト確定後の確実なスクロール適用
    if (this.initialScrollX !== 0) {
      nextTick(() => {
        setTimeout(applyScroll, 50);
      });
    }
  }
})
</script>
  
<style lang="scss" scoped>
.scrollable-panel__wrapper {
  /* 縦スクロールと横スクロールの両方をここで一括管理する */
  overflow: auto;
  height: calc(100vh - 100px);
  width: 100%;
}

.scrollable-panel {
  display: flex;
  flex-wrap: nowrap;
  /* 中身のサイズに合わせて flex コンテナの幅を限界まで広げる */
  width: max-content;
  min-width: 100%;
}

.scrollable-panel__left {
  position: sticky;
  left: 0; /* 横スクロール時に左端に固定 */
  z-index: 20; /* 中央のヘッダーが潜り込まないように高めに設定 */
  background-color: white; 
}

.scrollable-panel__center {
  position: relative;
  z-index: 1; /* z-indexの階層をリセットし、左右パネルの下をくぐるようにする */
  background-color: white;
}

.scrollable-panel__right {
  position: sticky;
  right: 0; /* 横スクロール時に右端に固定 */
  z-index: 20; /* 中央のヘッダーが潜り込まないように高めに設定 */
  background-color: white; 
}

.scrollable-panel__col__header {
  position: sticky;
  top: 0; /* 縦スクロール時に上端に固定 */
  background-color: white;
  z-index: 10;
  width: max-content; 
  min-width: 100%;
}

.scrollable-panel__col__body {
  width: max-content; 
  min-width: 100%;
}
</style>